import './footer.css';

import CopyRight from '../../assets/images/copyright.png';

export default function Footer() {
    return (
        <a href="http://www.fitlk.com" target="_blank" id="footer__fitlk" rel="noreferrer">
            <img src={CopyRight} alt="" className="me-1 mb-1" />
            Flexible Information Technology PVT LTD
        </a>
    )
}